export default "__VITE_ASSET__Bg$O2RyD__"